import axios from "axios";
import { authenticatedApiConfig } from "./BaseApiService";
export class SearchService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async classicSearch(searchInput, studyId) {
        const response = await axios.post(`${this.environment.API_BASE_URL}/search?studyId=${studyId}`, searchInput, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async search(searchInput, studyId) {
        const response = await axios.post(`${this.environment.API_BASE_URL}/search2?studyId=${studyId}`, searchInput, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
}
